var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "youtube 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.7747 6.37625C22.5154 5.41234 21.7554 4.6525 20.7916 4.39294C19.0309 3.91119 11.988 3.91119 11.988 3.91119C11.988 3.91119 4.94536 3.91119 3.18466 4.37468C2.23943 4.63396 1.46091 5.41248 1.20163 6.37625C0.738281 8.13681 0.738281 11.788 0.738281 11.788C0.738281 11.788 0.738281 15.4576 1.20163 17.1997C1.46118 18.1635 2.22089 18.9233 3.1848 19.1829C4.9639 19.6648 11.9883 19.6648 11.9883 19.6648C11.9883 19.6648 19.0309 19.6648 20.7916 19.2013C21.7555 18.9419 22.5154 18.182 22.7749 17.2182C23.2381 15.4576 23.2381 11.8065 23.2381 11.8065C23.2381 11.8065 23.2567 8.13681 22.7747 6.37625ZM9.7457 15.1611V8.4149L15.6022 11.788L9.7457 15.1611Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrgYoutube);
export default __webpack_public_path__ + "static/media/orgYoutube.5cbcd0d2ac2e0f508c8bf4779210e133.svg";
export { ForwardRef as ReactComponent };